import {  type Demande } from "../../types/Demande";

import { useUpdateDemandeMutation } from "../../stores/OkOkStore";


import { Controller, useForm } from "react-hook-form";
import { useEffect, type JSX } from "react";
import AttachmentsSelector from "../Common/AttachmentsSelector";
import { useTrads } from "../../contexts/trads/useTrads";
import type { ResponseError } from "../../types/CommonReponse";


 function  DemandeUploadCreance ({demandeParam}: {demandeParam: Demande}): JSX.Element {
    const [updateDemande, result] = useUpdateDemandeMutation();
   

    const { control, handleSubmit, setError } = useForm({
        defaultValues:demandeParam,
        //shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const {translate}=useTrads();
    useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        // @ts-expect-error i est connu!
                        setError(i, {type:'validate',message: translate(errors[i])});  
                }
                result.reset();
            }
        }
    },[setError,result, translate]);

    return (
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :(
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :

        <>
        <form className="row" onSubmit={(event) => void handleSubmit(updateDemande)(event)}>
            <div className="col-12  mb-3">
                <p>{translate('demande_declarations')}</p>    
                <Controller
                    control={control}
                    name="declarations"
                    render={({ field }) => <AttachmentsSelector value={field.value} name={field.name} onBlur={field.onBlur} onChange={field.onChange} disabled={field.disabled} accept=" application/pdf" />}
                />
            </div>
            <div className="col-12  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>
            <p>
                <a href="https://signing.fts.bosa.belgium.be/sign?language=fr">{translate('demande_sign_numeric_pdf')}</a><br />
                <a href="https://www.ilovepdf.com/fr/signer-pdf">{translate('demande_sign_pdf')}</a>
            </p> 

        </form>
        </>
        )
    );
}

export default DemandeUploadCreance;